import { category } from "../action-types";

const initialState = {
  data: [],
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case category.FETCH_LOADING_CATEGORY:
      return {
        ...state,
        isFetching: true,
      };
    case category.FETCH_CATEGORY:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
